import { render } from "./OddBtnNormalize.vue?vue&type=template&id=d39db1c2&scoped=true"
import script from "./OddBtnNormalize.vue?vue&type=script&lang=js"
export * from "./OddBtnNormalize.vue?vue&type=script&lang=js"

import "./OddBtnNormalize.vue?vue&type=style&index=0&id=d39db1c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d39db1c2"]])

export default __exports__